import React, { useEffect, useState } from 'react';
import { Select, Spin } from 'antd';
import axios from 'axios';

const { Option } = Select;

const TaxProfileSelect = ({ value, onChange, placeholder = "Select Tax Profile" }) => {
    const [profiles, setProfiles] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchProfiles = async () => {
            setLoading(true);
            try {
                const token = localStorage.getItem('token');
                const res = await axios.get('/api/tax-profiles', {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setProfiles(res.data);

                // If it's a new product (no value) and we have a default profile, auto-select it
                if (!value) {
                    const defaultProfile = res.data.find(p => p.is_default);
                    if (defaultProfile && onChange) {
                        onChange(defaultProfile.id);
                    }
                }
            } catch (err) {
                console.error('Failed to fetch tax profiles:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchProfiles();
    }, []);

    if (loading && profiles.length === 0) return <Spin size="small" />;

    return (
        <Select
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            style={{ width: '100%' }}
            optionLabelProp="label"
        >
            {profiles.map(p => (
                <Option key={p.id} value={p.id} label={`${p.name} (${p.rate}%)`}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span>{p.name}</span>
                        <span style={{ color: '#888' }}>{p.rate}%</span>
                    </div>
                </Option>
            ))}
        </Select>
    );
};

export default TaxProfileSelect;
